import script from "./backIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./backIcon.vue?vue&type=script&setup=true&lang=js"

import "./backIcon.vue?vue&type=style&index=0&id=6d28bea4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d28bea4"]])

export default __exports__